
import { StationMetaScopes, SyncScopeChoice } from '../../constants/scopeConstants';

export interface StationData {
  layout_text_colors?: Record<string, import('../directives/layout-text-colors.directive').LayoutTextColor>;
  nearest_stations_info: NearestStationsInfo;
  'Station Name': string;
  station_name?: string;
  'buildingText'?:string;
  'Station ID': string;
  station_id?: string;
  "Station Uuid"?:string;
  version_number?: string;
  'Station Title': string;
  station_title?: string;
  station_code?: string;
  hide_code?: boolean;
  table_persist_info?: Record<string, any>;
  "Train Direction"?: string;
  "Station Division"?: string;
  "current_station_tin_range"?: string,
  "current_station_tag_range"?: string,
  "current_station_tin_range_min": any,
  "current_station_tin_range_max":any;
  "current_station_tag_range_min":any;
  station_address_1?:any;
  station_address_23?:any;
  lidar_central_line_location?:any;
  selected_station_building:string | string[] | null;
  modified_station_building?: any;
  show_station_building?: boolean;
  station_port?:any;
  psr:number,
  "REF SIP"?:any;
  tag_reassign?:boolean;
  tin_reassign?:boolean;
  pxPerKm?:number;
  tables_placement?:any;
  "oem"?:string;
  station_building_image?:any;
  track_names_vs_short_codes?:any;
  display_ymps?:boolean;
  station_building_track_names?:any;
  central_line_lat_long?:any;
  "current_station_tag_range_max":any;
  signal_strength?:any;
  central_line_location?:any;
  tower_location?:any;
  hindi_station_name?:string;
  Zone?: string,
  "fm_points"?: any;
  main_lines?:any,
  "Station Code"?: string;
  Section?: string;
  Signal: TrackSignal[];
  utils: UtilityAsset[];
  CROSSING: TrackCrossing[];
  section_type?:any;
  kavach_intervals?:any;
  'Adjustment Points': AdjustmentPoint[];
  'Communication Points': CommunicationPoint[];
  "Communication Range"?:{track_name:string, start:number, end:number}[];
  'DEAD END': DeadEnd[];
  'Trap Point': TrapPoint[];
  'Kavach Territory Ending Point': KavachTerritoryPoint[];
  'track_start_end_locations'?: TrackStartEndLocation[];
  'Track Tins'?: TrackTin[];
  // "Tin Data"?: TinData[];
  "Edit Tin Data"?:TinData[];
  max_cm_distances?:any;
  main_track_lengths?:any;
  adjacent_stations?:any;
  initial_gradient_plan?:any;
  "new_communication_points"?:any;
  Tags:StationTags,
  track_Display_offsets?:any;
  "Tin Color Map":{ [tin: string]: string },
  "Gradient Plan": GradientPlanEntry[];
  "Tower Information": TowerInformation;
  "tower_plotting_info"?: TowerPlottingInfo[];
  "MAX CM DISTANCES": MaxCMDistances;
  minimum_station_distance?:any;
  maximum_station_distance?:any;
  "minimum_station_distance_without_offsets"?: any,
  "maximum_station_distance_without_offsets"?: any,
  "Tin Dead Ends"?: TinDeadEnd[];
  track_circuits: TrackCircuitsGroup[];
  "Distance Pairs"?: DistancePair[];
  circuit_pairs?: DistancePair[];
  "trackDirectionMappings": TrackDirectionMapping[];
  revision_history?: RevisionHistoryEntry[];
  station_tag_summary: TagSummaryData;
  "REf RFID Tag Layout No"?: string,
  "TOC Version"?: string,
  "REF SIP ID"?: string,
  "version"?: string|number;
  author_review_table: any;
  // "Config Tin Data"?: TrackConfig[];
  track_start_end_directions?: TrackStartEndDirections;
  track_start_end_locations_without_offsets?:TrackStartEndLocation[];
  operations_list?:string[];
  approvedInfo?:any;
  approve_button?:boolean;
  "track_section_points"?: any;
  "section_range"?: any;
  "track_section_points_names"?: any[];
  bounding_box_data?: any;
  track_circuits_vertical_alignment?: any[];
  computed_communication_points?:any;
  "section-type-range"?:any;
  "side-type-range"?:any;
  "Track Profile Data Version"?:any;
  signaling_toc_points_data?:any;
  // Station meta info array
  station_meta_info?:any;
  // Sibling station meta scopes object containing boolean flags per scope-able field
  station_meta_scopes?: StationMetaScopes;
  // Adjacent station visual config object
  adjacent_station_visual_config?: {
    left_station?: {
      x: number;
      y: number;
    };
    right_station?: {
      x: number;
      y: number;
    };
    up_dn_left_station?: {
      x: number; y: number;
    };
    reverse_nominal_left_station?: {
      x: number; y: number;
    };
    up_dn_right_station?: {
      x: number; y: number;
    };
    reverse_nominal_right_station?: {
      x: number; y: number;
    }
  };
  signal_size_ratio?: number;
  turnout_signals?:any;
  "Normal Tag Locations"?:any;
  "main_lines_direction_map"?:any;
  ymp_data?:any;
  legend_table?:any;
  border_line_tags_table?: any;
  legend_tag_color_table?: any;
  sil0_note_table?: any;
  division_table?: any;
  head_quarters_table?: any;
  approved_table?: any;
  check_approved_table?: any;
  right_legend_table:any;
  signal_telecommunication_single_data_table?:any;
  signal_telecommunication_ref_sig_plan_table?:any;
  "signal_telecommunication_double_data_table"?:any
  "ip_port_table"?:any;
  arrow_lines?: any;
  "compass_plotting_info"?: any;
  is_anti_collision_required?: boolean;
  hide_Non_Kavach_Location?: boolean;
  is_update_layout?: boolean;
  deleted_tag_info?: DeletedTagInfo;
  deleted_tin_info?: DeletedTinInfo;
  ref_sig_plan_checked_table?:any;
  regenerate_persistence_relation_info?: RegeneratePersistenceInfo;
  track_parity?: TrackParity[];
  signatures_table?: any;
  show_track_codes?: boolean;
  spare_mode?: boolean;
  update_only_layout?: boolean;
  ymp_reassign?: boolean;
  generateRestrictedComments?:boolean;
  showPersistedTagTinNumbers?: boolean;
  tunnels?: StationTunnel[];
  showLineNumbers?: boolean;
  apply_anti_collision_on_update?: boolean;
  asset_pairs?: any;
  show_asset_distance_pairs?: any;
  feature_flags?: StationFeatureFlags;
  duplicate_tag_numbers?: any;
  input_border_tags_data?: InputBorderTrackData[];
}

export interface ManualBorderTag {
  type_of_tag: 'S' | 'N' | 'X' | string;
  location: number;
  track_name?: string;
  tag_id?: string;
  is_bidirectional_left_to_right?: boolean | string;
  [key: string]: any;
}

export interface InputBorderTrackData {
  track_name: string;
  generate_border_tag?: boolean;
  manual_border_tags?: ManualBorderTag[];
  [key: string]: any;
}

export interface StationFeatureFlags {
  circuit_location_centered?: boolean;
  hideIndicatorQuotes?: boolean;
  manual_persistence_synced?: boolean;
  track_parity_rule?: 'new' | 'old';
  update_tag_offset?: boolean;
  boards_is_cr_wr?: boolean;
  border_tags_inputs_synced?: boolean;
  border_tags_updated?: boolean;
  [key: string]: any;
}


export interface StationTunnel {
  trackName: string;
  tunnels: TunnelInfo[];
}

export interface TunnelInfo {
  id: string;
  label: string;
  startAbsLocation:number;
  endAbsLocation:number;
  startLocation: number;
  endLocation: number;
  metadata?: TunnelMetadata;
  modified?: Partial<TunnelInfo>;
  change_type?: 'added' | 'deleted' | 'updated';
  is_version_change?: boolean;
}

export interface TunnelMetadata {
  startArrowConfig?: ArrowConfig;
  endArrowConfig?: ArrowConfig;
}

export interface ArrowConfig {
  visible?: boolean;
  direction?: 'left' | 'right';
}



export interface StationTags {
    'Normal Tags'?: TrackTagModel[];
    "Signal Tags"?: TrackTagModel[];
    "Gate Tags"?: TrackTagModel[];
    "Exit Tags"?: TrackTagModel[];
    "Border Tags"?: TrackTagModel[];
    "Dead Stop Tags"?:TrackTagModel[];
    "Line Adjustment Tags"?: TrackTagModel[];
    "Adjustment Tags"?: TrackTagModel[];
    'Turnout Tags'?: TurnoutTag[];
    // "Turnout Rfid Tins"?: TurnoutRfidTins[];
    "Hidden Tags"?:TrackTagModel[];
  }

export interface ConfiTinAsset {
  tin_number?: string;
  new_tin_number?: string;
  start: number;
  end: number;
  section_type: string; // Add more string literals if needed
  track_id: string;
  side?:any;
  tin_edit?:boolean;
  manual_edit_tin_number?: string;
  chs_asset?:any;

}

export const DIVISIONS = {
  SECUNDERABAD: 'secunderabad',
  NANDED: "nanded",
  RATLAM: 'ratlam',
  MUMBAI: 'mumbai',
  PUNE: 'pune',
}

export interface TrackDirectionInfo {
  track_code: string; // e.g., 'DMT'
  track_fullname: string; // e.g., 'DOWN MAIN LINE'
  arrow_direction: "left" | "right" ;
  view_direction: 'up' | 'down'; // Direction of the track view
  visual_config?: {
    start_label?: {  // Left side label
      x: number;
      y: number;
    };
    end_label?: {    // Right side label
      x: number;
      y: number;
    };
  };
   label_style?: {
    fontSize: number;
    color: string;
    fontWeight: 'normal' | 'bold';
  };
}
// Junction text formatting configuration
export interface JunctionTextFormatting {
  fontSize: number;
  fontWeight: number;
  color: string;
  isVisible?: boolean;
  decimalPlaces?: number;
}

export interface LegendTag {
  key: string;
  label: string;
  shape: 'polygon' | 'rect' | 'ellipse';
  property: string;
  exportSymbol?: string;
  defaultText?: string;
  strokeColor?: string;
  textColor?: string;
  symbolWidth?: number;
  symbolHeight?: number;
  rectX?: number;
  rectY?: number;
  rectWidth?: number;
  rectHeight?: number;
  ellipseCx?: number;
  ellipseCy?: number;
  ellipseRx?: number;
  ellipseRy?: number;
  textX?: number;
  textY?: number;
  fontSize?: number;
  fontWeight?: 'normal' | 'bold';
  viewBox?: string;
}

// All junction formatting options
export interface JunctionFormatting {
  left_junction?: JunctionTextFormatting;
  left_station?: JunctionTextFormatting;
  left_distance?: JunctionTextFormatting;
  right_junction?: JunctionTextFormatting;
  right_station?: JunctionTextFormatting;
  right_distance?: JunctionTextFormatting;
  [key: string]: JunctionTextFormatting | undefined;
}

export interface TrackStartEndDirections {
  'tracks': TrackDirectionInfo[];
  junction_name_above_track: string;
  showTrackNames?: boolean;
  visual_config?: {
    left_junction?: {
      x: number;
      y: number;
    };
    left_station?: {
      x: number; y: number;
    };
    left_station_kernex?: {
      x: number; y: number;
    };
    right_junction?: {
      x: number;
      y: number;
    };
    right_station?: {
      x: number; y: number;
    };
    right_station_kernex?: {
      x: number; y: number;
    }
  };
  is_version_change?: boolean;
  modified_assets?: any;
  junction_formatting?: JunctionFormatting; // NEW: formatting support
  kernex_junction_formatting?: JunctionFormatting;
}

export interface TrackConfig {
  track_name: string;
  assets: ConfiTinAsset[];
}


export interface TagPoint {
  dom_id_suffix: string;
  rfid_tag: string;
  rfid_tag_location: number;
  type_of_tag: string; // "N", "S", etc.
  id?: string;
  // Only on a gate end of a pair
  gate_asset_id?: string;
}

export interface DistancePair {
  track_name: string;
  distance: number; // e.g., "200 m"
  direction: string; // e.g., "up" or "down"
  from: any;
  to: TagPoint;
  tag_metadata?:any;
   fontSize?: number;
  color?: string;
  fontWeight?: 'normal' | 'bold';
}


export interface TurnoutRfidTins {
  rfid_tag: string;
  tag_direction?:any;
  type_of_tag: string; // e.g., 'T' for Turnout
  tag_description: string; // Description like 'Turnout Tag'
  Track1: string; // Primary track name
  Track2: string; // Secondary track name
  location: any; // Tag location as a string
  turnout_id: string; // Turnout identifier
  "Track 1 location": number; // Location on Track 1
  "Track 2 location": number; // Location on Track 2
  tag_placement: string; // Placement of the tag
  asset_id: string; // Asset identifier
  "Track 1": string; // Primary track name
  "Track 2": string; // Secondary track name
  "Track 1 Location": number; // Location on Track 1
  "Track 2 Location": number; // Location on Track 2
  "Track 1 Attached"?: string | boolean,
  "Track 2 Attached"?: string | boolean,
  mid_point: number; // Midpoint location
  midpoint?:string;
  "FM Point"?: string; // FM Point location
    midpoint_x?:number;
  midpoint_y?:number;
  coords?:any;
  direction?:any;
  tin_numbers: {
    loc1: number; // Start location of the tin
    loc2: number; // End location of the tin
    tin_number: string; // Tin identifier
    color?:any;
  }[];
  offset_location?: string | number; // Optional offset location for the tag
  "Track_1_offset_Location": number,
  "Track_2_offset_Location":number,
  is_beside_station?: string; // Optional, e.g., 'True' or 'False'
  mid_point_original?: number; // Optional, original midpoint location
  merge_horiz_segment?: boolean; // Optional, used to indicate if horizontal segments should be merged
  new_rfid_tag?: string; // Optional, used for new RFID tags
  SIP_Track_1_asset_id?: string; // Optional, used for SIP Track 1 asset ID
  SIP_Track_2_asset_id?: string; // Optional, used for SIP Track 2 asset ID
  new?:boolean;
  id?:string;
}
export interface TinDeadEnd {
  displayDeadEndBackGround?:boolean ;
  tin_number?: string;
  asset_id: string;
  location: number;
  type_of_dead_end: string;
  track_name: string;
  non_kavach: string;
  display_location: number; // Optional, used for display purposes
  view_direction?: string; // Optional, used for view direction
  view_x_axis_offset?: string | number; // Optional, used for x-axis offset in view
  displayDeadEndLocation?: boolean,
  displayDeadEndType?: boolean;
  displayDeadEnd?: boolean;
  deadEndVariant: string;
  id?: string;
  color?: string;
  change_type?: string;
  modified?: { type_of_dead_end?: string; asset_id?: string; tin_number:string; display_location?: number; [key: string]: any };
}
export interface DeadEnd {
  asset_id: string;
  location: number;
  type_of_dead_end: string;
  track_name: string;
  non_kavach: string;
  display_location: number;
  id?: string;
  deadEndVariant?: string;
  tin_number?: string;
  view_direction?: string;
  view_x_axis_offset?: string | number;
  dead_stop_tag?: any;
  displayDeadEnd?: boolean;
  displayDeadEndLocation?: boolean;
  displayDeadEndType?: boolean;
  displayDeadEndBackGround?: boolean;
  color?: string;
  change_type?: string;
  modified?: Record<string, any>;
  is_type_change_new?: boolean;
  indicator_config?: TrapPointIndicatorConfig;
  present?: boolean;
  direction?: 'up' | 'down';
  length?: number;
  zoneBasedDisplay?: boolean;
}

export interface TowerInfo {
  station_name: string;
  location: number;
  visual_config?: {
    x: number; // SVG x position
    y: number; // SVG y position
  };
}
export interface TowerInformation {
  TOWER_LEFT: TowerInfo;
  TOWER_CENTER: TowerInfo;
  TOWER_RIGHT: TowerInfo;
}

export interface TowerPlottingInfo {
  id?: string;
  x_offset?: any;
  tower_id?: number;
  tower_plotted: boolean;
  tower_length: string;
  tower_length_color?: string;
  modified_tower_length?: string;
  modified_tower_length_color?: string;
  tower_display_location: string;
  tower_display_location_color?: string;
  modified_tower_display_location?: string;
  modified_tower_display_location_color?: string;
  tower_symbol_color?: string;
  tower_offset: number;
  is_hidden?: boolean;
  hide_old_tower_length?: boolean;
  hide_old_tower_display_location?: boolean;
  change_type?: string;
  is_version_change?: boolean;
  modified_assets?: Record<string, any>;
  visual_config?: {
    x: number; // location in meters
    y?: number; // SVG y position (optional)
    scale?: number; // tower size multiplier (default 1)
  };
}
export interface MaxCMDistances {
  Maximum_Left_CM_Distance: number;
  Maximum_CM_Distance: number;
  Maximum_Right_CM_Distance: number;
  Left_signal_strength?:string;
  Right_signal_strength?: string;
  Center_signal_strength?: string;
}

// "Maximum_Left_CM_Distance": 3.5,
//   "Left_signal_strength": "70db",
//     "Maximum_CM_Distance": 3.9,
//       "Center_signal_strength": "70db",
//         "Maximum_Right_CM_Distance": 4.0,
//           "Right_signal_strength": "70db"
export interface GradientPlanEntry {
  "Entry Signal": string;
  "Exit Signal": string;
  "Engineering Gradient": string[];
}


export interface EngineeringGradientSegment {
  gradient: string;  // e.g., "R 1 in 150", "Level", "F 1 in 260"
  distance: number;  // e.g., 297, 552
}


// export interface CommunicationPoint {
//   BORDER_ENTRY: number;
//   BORDER_EXIT: number;
// }

// export interface NewCommunicationPoints {
//   [trackName: string]: CommunicationPoint;
// }


export  interface TrackStartEndLocation {
  track_name: string;
  min_location: number;
  max_location: number;
  id?:string;
  display_track_code: boolean,
  display_track_full_name: boolean,
  modified?: Partial<TrackStartEndLocation>;
};

//1. Nearest Stations Info
export interface NearestStationsInfo {
  right_junction_distance?:string;
  left_junction_distance?:string
  left_station_name: string;
  left_station_id: string;
  left_side_next_approaching_stop_signal: string;
  right_station_name: string;
  right_station_id: string;
  right_side_next_approaching_stop_signal: string;
  left_junction_name?: string; // Optional, used for left junction name
  right_junction_name?: string; // Optional, used for right junction name
  left_junction_name_lidar?: string; 
  right_junction_name_lidar?: string; 
  left_station_name_lidar?: string; 
  right_station_name_lidar?: string;
  left_tag_range?: string;
  right_tag_range?: string;
  left_tin_range?: string;
  right_tin_range?: string;
  left_station_track_lengths?:any;
  right_station_track_lengths?:any;
  left_distance?: number;
  right_distance?: number;
  left_station_center_line?: number | string;
  right_station_center_line?: number | string;
  left_km_dist_override?: number;
  right_km_dist_override?: number;
}

//2. Signals & Tracks
export interface TrackSignal {
  track_name: string;
  assets: SignalAsset[];
  id?:string;
}

export interface SignalAspectChange {
  value: string;
  change_type?: 'added' | 'deleted';
  color?: string;
}

// One SignalHornChange = one horn drawing the version-change screen must show.
// A replaced horn produces TWO of these: the old horn (change_type 'deleted',
// drawn green) and the new horn (change_type 'added', drawn red).
export interface SignalHornChange {
  horn_alignment: 'horizontal' | 'vertical';
  horn_style: 'standard' | 'wr';
  // 'added' -> new horn, draw red.  'deleted' -> old horn, draw green,
  //  no change_type means that horn is present in both old and new
  change_type?: 'added' | 'deleted';
  // Exact stroke colour for THIS horn. Per-entry because on one signal the old
  // horn is green and the new horn is red at the same time.
  color?: string;
  /**
   * A full copy of the signal's slot order, attached to this entry only when the horn moved to a different 
   * slot (not when it only changed look). It lets the renderer put the green horn back where it used to 
   * sit and the red horn where it now sits, both at once, instead of stacking them at one spot.
   */
  symbolSequenceOrder?: { key: string; is_hidden?: boolean }[];
  /**
   * Set when the user edited this entry's alignment/style directly in the
   * version-change popup (onHornFieldChange), as opposed to the entry being
   * derived from the signal's own old/new horn fields.
   */
  isManuallyEdited?: boolean;
}

export interface SignalAsset {
  color?: string;
  tag_color?: string;
  asset_id: string;
  signal_label?:string[];
  signal_label_color_map?: Record<string, string>;
  location: number ;
  assetFontSize?: number;
  default_representation?:boolean
  assetColor?: string;
  track_name?:string;
  assetFontWeight?: 'normal' | 'bold';
  visible_left_to_right: string; // "True"/"False"
  visible_right_to_left: string;
  asset_category: string;
  asset_edit?: boolean;
  signal_aspects?: string[];
  signal_id_inside_board?:boolean,
  display_phone?: boolean;
  phone_style?: 'inverted' | null; // null = standard SPT phone; 'inverted' = flipped handset, no lamps
  is_beside_station: string;
  non_kavach?: string;
  is_filled?: boolean;
  istext?: boolean;
  signal_placement?:string;
  sub_track?:string;
  type_of_communication_point?: string;
  aspects_with_root_indicators?: any;
  aspects_with_slots?: any;
  ag_marker_raised: boolean;
  has_slot?:any;
  berthing_track_signal?: string | boolean; // "True"/"False"
  offset_location?: number; // Optional offset location for the signal
  tin_numbers?: string[]; // List of tin numbers associated with the signal
  assumed_bslb_signal?: boolean;
  block_section?:boolean;
  is_advance_starter?:boolean;
  released_by?: boolean;
  is_calling_on_symbol_present?:any;
  signal_img_view_direction?:string;
  original_asset_id?: string; // Optional, used for original asset ID
  beside_station_id?: string; // Optional, used for beside station ID
  need_to_plot?:string; // Optional, used to indicate if the signal needs to be plotted
  id?:string;
  count_of_shunt_aspects?:any;
  arrow_mark_position?:string;
  arrow_mark_direction?:any;
  arrow_is_dotted?:boolean;
  plot_location?:any;
  communication_label_name?:any;
  tag_metadata?:any;
  bi_directional?:any;
  automatic_notation?:any;
  board_present?:any;
  slot_position?:string;
  board?: {
    board_present: boolean;
    board_text: string;
    board_text_position?: 'inside' | 'outside';
    // middle board only: extra text drawn outside while board_text is inside
    board_outside_text?: string;
    board_text_rotation?: 'vertical' | 'horizontal';
    board_orientation?:string;
    board_display?:string;
    count?: number;
    present_on_signal?: boolean;
    show_board_text_arrow?: boolean;
    arrow_mark_position?: string;
    arrow_mark_is_dotted?: boolean;
    board_is_dotted?: boolean;
    arrow_mark_shape?: 'polygon' | 'dot_with_circle';
    attributes: any;
    color?: string; 
  };
  non_signaling_zone?:boolean;
  "signalAspectsOptions"?:any;
  display_communication_point?:any;
  "comm_start"?: any;
  "comm_end"?: any;
  "comm_start_location"?: any;
  "comm_end_location"?: any;
  comm_start_displayLocation?:any;
  comm_end_displayLocation?:any;
  comm_start_text_displayLocationX?:any;
  comm_start_text_displayLocationY?:any;
  comm_end_text_displayLocationX?:any;
  comm_end_text_displayLocationY?:any;
  comm_start_id?:any;
  comm_end_id?:any;
  comm_start_id_offsets?:any;
  comm_end_id_offsets?:any;
  is_dotted?: boolean;
  hide_tag?: boolean,
  hideTag?: boolean,
  is_height?:boolean,
  board_in_opposite_direction?:boolean,
  stencil_before_indicators?:boolean,
  aSymbolPosition?:any,
  aSymbolDirection?:any,
  symbolSequenceOrder?: { key: string; label: string, is_hidden?: boolean }[],
  agMarkerDirection?:string,
  ag_marker_style?: 'ag_symbol' | 'empty',
  gate_signal_placement?: GateSignalPlacement,
  // Generic raised-symbol placement toggle. When 'horizontal', any eligible
  // raised symbol (permissive, gate, etc. — but NOT the automatic/semi-automatic
  // A-symbol) is rendered inline on the arm instead of on a raised connector.
  raised_symbol_placement?: GateSignalPlacement,
  // WR-only: when true, calling-home signals render the normal other-zone
  // calling-home symbol instead of the Western Railway (WZ) variant.
  callingHomeDefault?: boolean,
  aSymbolShowLetter?:boolean,
  a_symbol_style?: 'white' | 'black' | 'empty';
  a_symbol_display?: string;
  extendedIndicators?:boolean,
  track_circuit_points?: any;
  track_section_names?: any;
  circuit_pointing_location?: any;
  section_pointing_location?: any;
  track_circuit_add?: any;
  b_symbol_style?: 'circular' | 'plane';
  horn_style?: 'standard' | 'wr';
  
  // In version-change code paths has_horn means "did the OLD / baseline side
  // have a horn?", NOT "is a horn drawn now". The popup's writeHornChanges()
  // sets it from the change entries, and compareSignalHorn() reads it that way.
  has_horn?: boolean;
  // Orientation of the horn on the arm. Absent / null / '' is treated as
  // 'vertical' everywhere
  horn_alignment?: 'horizontal' | 'vertical';
  b_symbol_behind_line?: boolean;
  circleForCallingOnSymbol?: boolean;
  shunt_light_style?: 'filled' | 'empty';
  shunt_symbol_style?: ShuntSymbolStyle;
  spi_shunt_style?: 'spi_shunt_signal' | 'spi_shunt2';
  attached_to_pole?: boolean;
  kink_signal?:boolean;
  stop_board_label?: string;
  stop_board_show_arrow?: boolean;
  rotation?: number;
  // Appended to every DOM id derived from this signal so version-change
  // copies don't collide with the source signal's DOM elements. Same
  // mechanism as TrackTagAsset.dom_id_suffix.
  dom_id_suffix?: string;
  // Marker set by the version-change popup's Copy action. When true the
  // popup's signal fields write straight to the actual keys instead of
  // accumulating in a `modified` diff block.
  is_version_change?: boolean;
  // Version-change diff for signal aspects. Entries without change_type are
  // retained/current aspects; deleted entries are appended with
  // change_type='deleted' so the UI can derive the live aspect list without
  // mutating the baseline signal_aspects array.
  aspect_changes?: SignalAspectChange[];
  // The horn diff for this signal. Written by RedAndGreenService.compareSignalHorn()
  // (and by the version-change popup). Present here at the top level for older
  // saved layouts; the current diff writes it into `modified.horn_changes` below.
  // Every reader checks `modified?.horn_changes ?? horn_changes`.
  horn_changes?: SignalHornChange[];
  // Per-root-indicator and per-slot color overrides keyed by the indicator's
  // `aspect` field (or `indicator_<n>` when the entry has no aspect).
  root_indicator_color_map?: { [aspectKey: string]: string | { [indicatorKey: string]: string } };
  slot_indicator_color_map?: { [aspectKey: string]: string | { [indicatorKey: string]: string } };
  // Pending value changes proposed for this signal (mirrors the
  // TrackTagAsset.modified pattern). Only the fields the version-change
  // popup edits are typed here.
  modified?: {
    location?: number;
    asset_category?: string;
    signal_aspects?: string[] | string;
    aspect_changes?: SignalAspectChange[];
    horn_changes?: SignalHornChange[];
    aspects_with_root_indicators?: any;
    aspects_with_slots?: any;
  };
}

export enum GateSignalPlacement {
  Raised = 'raised',
  Horizontal = 'horizontal'
}

export enum ShuntSymbolStyle {
  Slant = 'slant',
  Straight = 'straight',
  TopDiagonal = 'top_diagonal'
}


export const resolveShuntStraightStyle:any = (
  styleOverride: ShuntSymbolStyle | null | undefined,
  defaultStraight: boolean
): boolean => {
  if (styleOverride === ShuntSymbolStyle.Straight) return true;
  if (styleOverride === ShuntSymbolStyle.Slant) return false;
  return defaultStraight;
};

export interface SignalAspectWithIndicator {
  aspect: string;
  count?: number;
  // directions can be old way (array) or new way (object with arrays)
  directions?: {
    upward?: string[];
    downward?: string[];
    vertical_up?: string[];
    vertical_down?: string[];
    backward_up?: string[];
    backward_down?: string[];
    linear?: string[];
  } | string[];
  // old format had separate symbols object
  symbols?: {
    upward?: string;
    downward?: string;
  };
}

export interface AssetWithTrack {//only used in svgs to draw the signal
  track_name: string;
  asset: SignalAsset;
}

export enum GateType {
  SB = 'SB',
  EOLB = 'EOLB',
  DGPB = 'DGPB',
  DGPB2 = 'DGPB2',
}


// 3. Utility Assets (e.g., Center, Gates, Sliding Boom)
export interface UtilityAsset {
  type_of_asset: string;
  asset_id: string;
  gate_type?: GateType;
  shape?: 'rectangle' | 'circle' | 'triangle';
  y_offset?: number;
  location?: number;
  // Optional absolute location (used by ASB stored in utils).
  abs_location?: number;
  track_name?: string; // optional for center,
  "LC/Gate ID"?: number,
  "LC Class"?: string,
  "LC Gate Class Text"?: string,
  "LC Manning Type"?: string,
  "LC Locking Type"?: string,
  "LC/Gate Alpha ID"?:any;
  // Extended gate label (HBL / non-Kernex / non-Swaga) — per-line draggable + visibility flags
  gate_no_offset_x?: number;
  gate_no_offset_y?: number;
  lc_locking_offset_x?: number;
  lc_locking_offset_y?: number;
  lc_manning_offset_x?: number;
  lc_manning_offset_y?: number;
  hideGateNoText?: boolean;
  hideGateLockingText?: boolean;
  hideGateManningText?: boolean;
  offset_location?:number;
  is_beside_station?:string; // Optional, e.g., 'True' or 'False'
  block_section?:boolean;
  is_dotted?:boolean;
  is_dashed?:boolean;
  is_center_dashed?:boolean;
  isCenterDashed?:boolean;
  text?: string ;
  tag_metadata?: any;
  isEditing?: boolean;
  // Text box background: true = transparent, otherwise white
  is_transparent?: boolean;
  // Sliding boom specific properties
  gate_location?: 'top' | 'bottom';
  direction?: 'left' | 'right';
  present?: boolean;
  sliding_boom_scr_type?: SlidingBoomScrType | string;
  x_offset?:number;
  showMultiple?: boolean;
  displayTrackName?: string | null;
  id?:string;
  showLocation?:boolean;
  showLocationAtTop?:boolean;
  bold?:boolean;
  fontSize?: number;
  color?: string;
  rotation?: number;
  gate_color?: string;
  gate_rotation_angle?: number;
  arrowsFlipped?: boolean;
  topArrowFlipped?: boolean;
  bottomArrowFlipped?: boolean;
  boomFlipped?: boolean;
  isFlipped?: boolean;
  isFlippedVertical?: boolean;
  // DGPB/DGPB2 draw each boom record twice (one copy per gate side), so the vertical
  // "key" flip is held per side. Unset falls back to the shared isFlippedVertical.
  isFlippedVerticalLeft?: boolean;
  isFlippedVerticalRight?: boolean;
  isSlideLockBoomFlipped?: boolean;
  isFlashBoomFlipped?: boolean;
  isTripleBoomFlipped?: boolean;
  top_boom_offset_y?: number;
  bottom_boom_offset_y?: number;
  label_offset_x?: number;
  label_offset_y?: number;
  location_offset_x?: number;
  location_offset_y?: number;
  asset_id_offset_x?:number;
  asset_id_offset_y?:number;
  is_hidden?:boolean;
  hide_booms?: boolean;
  hide_arrows?: boolean;
  remove_boom_color?: boolean;
  sliding_boom_in_front?: boolean;
  // ASB/utility rendering metadata: variant (up/down/left/right/dotted).
  sub_type?: string;
  // ASB/utility rendering metadata: image source path.
  imgPath?: string;
  // Gate center specific properties
  gatecenter_visible?: boolean;
  gatecenter_x_offset?: number;
  gatecenter_y_offset?: number;
  guide_line_visible?: boolean;
  guide_line_offset_x?: number;
  guide_line_offset_y?: number;
  guide_line_length?: number;
  guide_line_left_arrow?: boolean;
  guide_line_right_arrow?: boolean;
  modified_assets?: any;
  change_type?: 'added' | 'deleted' | string;
  modified?: Partial<UtilityAsset> | any;
  is_version_change?: boolean;
  text_type?:string;
}

export enum SlidingBoomScrType {
  SLIDING_BOOM_SCR_SVG = 'SLIDING_BOOM_SCR_SVG',
  SLIDING_BOOM_SCR_SVG_DOTTED = 'SLIDING_BOOM_SCR_SVG_DOTTED',
  SLIDING_BOOM_SCR_1_SVG = 'SLIDING_BOOM_SCR_1_SVG',
}

// 4. Track Crossings
export interface TrackCrossing {
  asset_id: string | number;
  track_1_non_kavach?: boolean | string | number;
  track_2_non_kavach?: boolean | string | number;
  track_1_non_kavach_asset_id?: string;
  track_2_non_kavach_asset_id?: string;               
  id?:string,
  color?: string;
  locationFontSize?: number;
  locationColor?: string;
  locationFontWeight?: 'normal' | 'bold';
   displayStyles?: {
    location1: {
      fontSize: number;
      color: string;
      fontWeight: 'normal' | 'bold';
    };
    location2: {
      fontSize: number;
      color: string;
      fontWeight: 'normal' | 'bold';
    };
    assetIdStyle?: {
     fontSize: number;
     color: string;
     fontWeight: 'normal' | 'bold';
   };
  }
  track1Arrow?:any;
  track2Arrow?:any;
  track1LocationFontSize?: number;
  track1LocationColor?: string;
  track1LocationFontWeight?: 'normal' | 'bold';
  
  track2LocationFontSize?: number;
  track2LocationColor?: string;
  track2LocationFontWeight?: 'normal' | 'bold';
  "mid_point"?: number,
  "mid_point_original"?: number,
  'Track 1': string;
  'Track 2': string;
  'trackBend'?:string;
  'track1Bend'?:string; // TOP track:    'normal' | 'above' | 'below'
  'track2Bend'?:string; // BOTTOM track: 'normal' | 'above' | 'below'
  'Track 1 Location': number;
  'Track 2 Location': number;
  "Track 1 Attached"?: string | boolean;
  "Track 2 Attached"?: string | boolean;
  "FM Point"?: string;
  midpoint?:string;
  "tin_numbers"?:any;
  "Track_1_offset_Location": number,
  "Track_2_offset_Location": number,
  "Track_1_offsetDiff"?: number,
  "Track_2_offsetDiff"?: number,
  midpoint_x?:number;
  midpoint_y?:number;
    ELEVATION?:any;
  SIP_Track_1_asset_id?: string; // Optional, used for SIP Track 1 asset ID
  SIP_Track_2_asset_id?: string; // Optional, used for SIP Track 2 asset ID
  merge_horiz_segment?: boolean; // Optional, used to indicate if horizontal segments should be merged
  visual_turnout_horizontal_length?: number;
  visual_turnout_vertical_length?: number;
  tag_metadata?: any; // Optional, used to store metadata like dragged positions for crossing IDs
  coords?: any;
  displayTrack1Location?: boolean;
  displayTrack2Location?: boolean;
  displayTrack1AssetId?: boolean;
  displayTrack2AssetId?: boolean;
  displayTriangle?: boolean;
  track_1_non_kavach_label?: string | null;
  track_2_non_kavach_label?: string | null;
  curvedCrossing?:boolean;
}

// 5. Adjustment Points
export interface AdjustmentPoint {
  track_name: string;
  ABS1: string;
  ABS2: string;
  location?:any;
  offset_location?:any
  type_of_communication_point: string;
  is_beside_station?:string; // Optional, e.g., 'True' or 'False'
}

// 6. Communication Points
export interface CommunicationPoint {
  id?: string;
  track_name: string;
  type_of_communication_point: string;
  location: number;
  rfid_tag?:string;
  signal?:any[]
  associated_rfid_tag?: string; // Optional, used for associated RFID tag
  associated_tag_type?: string; // Optional, used for associated tag type
  new_associated_rfid_tag?: string; // Optional, used for new associated RFID tag
  offset_location?:number;
   "comm_start"?: any;
  "comm_end"?: any;
  "comm_start_location"?: any;
  "comm_end_location"?: any;
  plot_location?:any;
  communication_label_name?:any;
  
}

// 8. Trap Points
// Trap Point Indicator Configuration for interactive editing
export interface TrapPointIndicatorConfig {
  // Fields for arrow-based trap points (regular trap points) - required for backward compatibility
  arrow_x: number; // Arrow tip X position (global SVG coordinates)
  arrow_y: number; // Arrow tip Y position (global SVG coordinates)
  arrow_abs?: number; // Arrow tip X in absolute km; present while auto-following location/zoom, deleted once the arrow is manually dragged
  arrow_angle: number; // Rotation angle in degrees (from initial direction: up=90, down=-90)
  asset_id_label_offset: {
    x: number; // X offset from arrow tip
    y: number; // Y offset from arrow tip
  };
  asset_label_style?: {
  fontSize: number;
  color: string;
};
location_label_style?: {
  fontSize: number;
  color: string;
};


  location_label_offset: {
    x: number; // X offset from arrow tip
    y: number; // Y offset from arrow tip
  };
  location_label_state?: number; // 0 = left side (normal), 1 = right side (flipped 180°)

  // Fields for manual trap point (SVG image) - optional, only used for Manual Trap Point type
  manual_x?: number; // Image center X position (global SVG coordinates)
  manual_y?: number; // Image center Y position (global SVG coordinates)
  manual_angle?: number; // Rotation angle: 0 or 180
}

export interface TrapPoint {
  asset_id: string;
  location: number;
  track_name: string;
  non_kavach: string;
  display_location:number;
  is_dead_end?: string;
  type_of_trap_point?: string; // Optional, used to specify the type of trap point
  manual_trap_point_variant?: 'variant1' | 'variant2' | 'variant3' | 'variant4';
  tin_number?:string;
  display_trap_point?: DisplayTrapPoint; // Optional, used for displaying trap points
  indicator_config?: TrapPointIndicatorConfig; // Optional, stores interactive indicator configuration
  id?:string;
  coords?:any;
  dead_stop_tag?:any;
  displayTrapPointLoc?: boolean;
  displayTrapPointType?: boolean;
  trap_point_arrow?: {
    present: boolean;
    direction: 'up' | 'down';
  };
  dead_end?: DeadEnd,
  color?: string;
}

// 9. Kavach Territory Ending Point
export interface KavachTerritoryPoint {
  id?: string;
  asset_id: string;
  location: number;
  track_name: string;
  non_kavach: string;
  is_beside_station?:string;
  type_of_trap_point?: string; // Optional, used to specify the type of trap point
  offset_location?:any;
  on_turnout?:any;
  turnout_id?:any;
}

export interface DisplayTrapPoint {
  position_on_tin: 'start' | 'end' | 'middle' | 'none'; // Indicates where the trap point is located

  bend_directions?: {
    /**
     * Applies only if location === 'middle'
     * Direction of the left bend
     */
    left?: 'up' | 'down' | 'none';

    /**
     * Applies only if location === 'middle'
     * display of the left bend
     */
    hideLeft?: boolean;

    /**
     * Applies only if location === 'middle'
     * Direction of the right bend
     */
    right?: 'up' | 'down' | 'none';

    /**
     * Applies only if location === 'middle'
     * display of the right bend
     */
    hideRight?: boolean;

    /**
     * Applies only if location === 'start'
     * Direction of the bend at the start
     */
    start?: 'up' | 'down' | 'none';

    /**
     * Applies only if location === 'end'
     * Direction of the bend at the end
     */
    end?: 'up' | 'down' | 'none';
  };
}
//Track Tins
export interface TinAsset {
  id?:string,
  tin_number: string;
  start: number;
  end: number;
  hideVirtualDeadEnd?:boolean,
  "start_offset"?: number,
  "end_offset"?: number,
  section_type?: string;
  color?: string;
  start_ignore?: boolean; // Optional, used to ignore the start location
  end_ignore?: boolean; // Optional, used to ignore the end location
    tin_style?: {
    fontSize?: number;
    fontWeight?: 'normal' | 'bold';
    color?: string;
  };
  "tin_number_display": {
    fontSize?: number;
    fontWeight?: 'normal' | 'bold';
    color?: string;
    fontColor?: string;
    "view_direction": string,
    "view_offset": number,
    "keep_tin_number":boolean,
    zero_offset?: boolean; // Optional, when true forces view_offset to 0 and locks it
    tin_show_id?: string|null; // Optional, used to specify the tin show ID
    offset_location?: string | number; // Optional, used for offset location
  },
  "adjustment_offsets": {
    "start_location_offset": number,
    "end_location_offset": number,
  },
  "adj_start_location":number,
  "adj_end_location": number,
  change_type?:string
  track_index?:string,
  contains_trap_point?: boolean | null; // Optional, used to indicate if the tin contains a trap point
  is_newly_created?: boolean; // Optional, used to indicate if the tin is newly created
  // side?: string; // Optional, used to specify the side of the tin
  side?: any; // Optional, used to specify the side of the tin
  tin_edit?:boolean;
  manual_edit_tin_number?: string;
  chs_asset?:any;
  displayTrapPointLoc?: boolean;
  displayTrapPointType?: boolean;
  mode?: string
  newly_added_tin?: boolean;
  start_added?: boolean;
  end_added?: boolean;
  end_uuid?: string;
  start_uuid?:string;
  merged?: boolean;
  adjustments_changed?: boolean;
  tin_outline_color?:string;
  modified?: any
}

export interface TrackTin {
  track_name: string;
  assets: TinAsset[];
  is_track_added?: boolean;
}

//Turn out tags
export interface TurnoutTag {
  rfid_tag: string;
  type_of_tag: string; // e.g., 'T' for Turnout
  tag_description: string; // Description like 'Turnout Tag'
  Track1: string; // Primary track name
  Track2: string; // Secondary track name
  location: number | string; // Tag location, parsed as number if needed
  turnout_id: string; // Turnout identifier
  'Track 1 location': number;
  'Track 2 location': number;
  rfidColor?: string;
  tag_color?: string;
  rfidFontSize?: number;
  rfidFontWeight?: string;
  locationColor?: string;
  locationFontSize?: number;
  locationFontWeight?: string;
  midpoint_x?:number;
  midpoint_y?:number;
  direction?:any;
  tag_direction?:any;
  tag_placement?:string;
  offset_location?: string | number;
  id: string;
  tag_metadata?: any;
  
  is_beside_station?: string; // Optional, e.g., 'True' or 'False'
  is_dotted?: boolean;
  "Track_1_offset_Location": number;
  "Track_2_offset_Location": number;
  "adj_end_location"?: number;
  "adj_start_location"?: number;
  "adjustment_offsets"?: {
    "end_location_offset"?: number;
    "start_location_offset"?: number;
  },
  "tin_number_display"?: {
    "keep_tin_number"?: boolean,
    "view_direction"?: string,
    "view_offset"?: number;
  },
   modified?: MODIFIEDTAG;
    dom_id_suffix?: string;
  is_version_change?: boolean;
  merge_horiz_segment?: boolean; // Optional, used to indicate if horizontal segments should be merged
  new_rfid_tag?: string; // Optional, used for new RFID tags
  tag_edit?: boolean; // Tag number persistence — set when the RFID/direction is edited by hand
  manual_edit_tag?: string;
}

// Represents a single track circuit with optional numeric locations
export interface TrackCircuit {
  circuit_name: string;
  start_location: string;  // You can change to number | "-" if you want stricter typing
  end_location: string;
  circuit_label_view_x_location?: string,
  circuit_label_view_y_location?: string,
}

// Represents a group of circuits associated with a track
export interface TrackCircuitsGroup {
  track_name: string;
  track_circuits_list: TrackCircuit[];
}



//Crossings or Turnouts
export interface TinData {
  tin_number_display?: {
    fontSize?: number;
    fontWeight?: 'normal' | 'bold';
    color?: string;

    view_direction?: string;
    view_offset?: number;
    keep_tin_number?: boolean;
  };
  tin_number: string;
  tin_info: TinInfo;
}

export interface TinInfo {
  tracks: TrackSegment[];
  crossings: TinCrossing[];
}

export interface TrackSegment {
  track_name: string;
  start: number;
  end: number;
}

export interface TinCrossing {
  crossing_id: string;
  loc1: number;
  loc2: number;
}


//Dead End types
export enum DeadEndType {
  BS_DEAD_END_NON_KAVACH = "BS DEAD END NON KAVACH",
  BS_DEAD_END_KAVACH = "BS DEAD END KAVACH",
   SAND_DEAD_END = "SAND DEAD END",
  END_KNOB = "END KNOB",
  LONG_DEAD_END = "LONG DEAD END",
  DUAL_DEAD_END = "DUAL DEAD END",
  CPB_DEAD_END = "CPB DEAD END",
  DEAD_END2 = "DEAD END2",
  SHED_DEAD_END = "SHED DEAD END",
  TWS_SHED_DEAD_END = "TWS SHED DEAD END",
  LONG_SHED_DEAD_END = "LONG SHED DEAD END",
}

/** Left-offset pixel values (negative = shift left) for non-Kavach dead ends. */
export enum NonKavachDeadEndLeftPx {
  SAND_DEAD_END = -60,
  END_KNOB = -35,
  TWS_SHED_DEAD_END = -69,
  SHED_DEAD_END = -69,
  LONG_SHED_DEAD_END = -69,
  LONG_DEAD_END  = -30,
  BS_DEAD_END_NON_KAVACH = -8,
  BS_DEAD_END_KAVACH = -8,
  DEFAULT = -8
}


export interface MODIFIEDTAG {
    location?: number | string;
    rfid_tag?: string;
    type_of_tag?: string;
    rfidColor?: string;
    locationColor?: string;
    distance_from_lc_gate_to_g_tag?: string;
    'ABS1 Location'?: string;
    'ABS2 Location'?: string;
    comm_arrow_config?: {
      visible?: boolean;
      direction?: 'left' | 'right';
      position?: 'above' | 'below';
      arrow_label_1?: string;
      arrow_label_2?: string;
      arrow_label_1_hide?: boolean;
      arrow_label_2_hide?: boolean;
      arrow_label_1_direction?: 'left' | 'right';
      arrow_label_2_direction?: 'left' | 'right';
      comm_label_color?: string;
      arrow_svg_offsets?: { x: number; y: number };
      arrow_label_1_offsets?: { x: number; y: number };
      arrow_label_2_offsets?: { x: number; y: number };
      comm_box_offsets?: { x: number; y: number };
      arrow_label_1_color?: string;
      arrow_label_2_color?: string;
      arrow_label_1_line_color?: string;
      arrow_label_2_line_color?: string;
      arrow_label_1_new?: string;
      arrow_label_2_new?: string;
    };
  };

//Normal Tags
export interface TrackTagAsset {
  displayName?:string;
  assumed_bslb_signal?:boolean;
  rfid_tag: string;
  id:string,
    // Text styling for RFID text
rfidFontSize?: number;
rfidColor?: string;
non_kavach?: string | boolean;
rfidFontWeight?: string;
 locationFontSize?: number;
  locationFontWeight?: string;
  locationColor?: string;
  abs1LocationColor?: string;
  abs1LocationFontSize?: number;
  abs1LocationFontWeight?: string;
  abs2LocationColor?: string;
  abs2LocationFontSize?: number;
  abs2LocationFontWeight?: string;
// Text styling for communication point text
commFontSize?: number;
commColor?: string;
commFontWeight?: string;
  signal_placement?:string;
  "direction_correction_1"?:any;
  "direction_correction_2"?:any;
  for_adjustment_tag?:any;
  type_of_tag: string;
  tag_description: string;
  visible_left_to_right?: 'True' | 'False';
  visible_right_to_left?: 'True' | 'False';
  asset_category?: string;
  type_of_asset?: 'signal_points' | 'communication_points' | string;
  nearest_signal_location?: any;
  unique_id?:any;
  x_location?:any;
  y_idx?:any;
  additional_tag?:any;
  point_name?:any;
  location: number | string;
  tag_info?:string;
  tin_numbers?: string[];
  signal_id?:string; //only for signal tags
  type_of_communication_point?: string; //only for singal tags
  view_direction?: 'up' | 'down'; // Direction of the tag view
  view_offset?: string | number; // Optional offset for the tag view which can be positive or negative
  "direction"?: string,
  "ABS1 Location"?: string,
  "ABS2 Location"?:string,
  "combined_abs1_abs2_location"?: string, // Combined ABS1 and ABS2 location
  "tag_placement"?: string,
  nearest_signal_id?:string | null, // Optional ID for the nearest signal
  // berthing_track_signal?: boolean; // Optional, e.g., 'True' or 'False'
  berthing_track_signal?: any; // Optional, e.g., 'True' or 'False'
  gate_location?: number, // Optional location for the gate tag
  offset_location?: string | number, // Optional offset location for the tag
  "gate_id"?: number,
  show_gate_no?: boolean,
  "lc_gate_class"?: string,
  tag_color?:string,
  is_advance_starter?:any;
  "lc_gate_manning_type"?:  string,
  "distance_from_lc_gate_to_g_tag"?:string,
  tag_ABS2_offsets?:any,
  tag_ABS1_offsets?:any,
  gate_tag_arrow_offsets?:any,
  gate_name_offsets?:any,
  is_calling_on_symbol_present?:boolean,
  section_type?: string,
  comm_required?: string,
  merged_normal_tag_rfid?: any; // Optional, used for merged normal tag RFID
   // Add communicationPoint as an optional field
   communicationPoint?: CommunicationPoint;  // This needs to be the appropriate type
  is_beside_station?: string; // Optional, e.g., 'True' or 'False'
  "nearest_signal_offset_location"?:number | null; // Optional, used for nearest signal offset location
  communication_point_name?: string; // Optional, used for communication points
  // Assets the tag was placed for: asset id -> details, like the communication point the tag draws
  meta_data_dependencies?: Record<string, TagDependency>;
  new_rfid_tag?: string; // Optional, used for new RFID tags
  is_dashed_view?: boolean; // Optional; indicates whether the tag should be displayed as dashed
  dead_end_location?:number;
  associated_shunt_signal?: string | null; // Optional, used for associated shunt signal;
  tag_edit?:boolean,
  manual_edit_tag?: string;
  tag_changed?:boolean,
  hideTag?:boolean;
  new_view_direction?: 'up' | 'down'; // version changes: new view direction (old side green, new side red)
  gate_arrow_color?: string; // version changes: gate arrow color at old side
  hideLocation?:boolean;
  "comm_start"?: any;
  "comm_end"?: any;
  "comm_start_location"?: any;
  "comm_end_location"?: any;
  comm_start_displayLocation?:any;
  polylinePoints?:any;
  comm_end_displayLocation?:any;
  tag_metadata?:any;
  physical_adjustment_tag?:boolean;
  adjustment_info?:string;
  plot_location?:any;
  comm_offsets?:any;
  comm_bi_offsets?:any;
  communication_label_name?:any,
  is_dotted?:boolean;
  distance_pole_dotted?:boolean; // Optional; dots this tag's pole specifically when it is a Distance Pair endpoint
  gate_tag_arrow_direction?:string;
  assumed_bslb_arrow_direction?:string;
  hide_assumed_bslb_arrow?:boolean;
  show_border_box?: boolean;
  showCommLabel?:boolean;
  tagDirection?: boolean;
  mode?: string;
  dashed_border_box?:boolean;
  comm_arrow_config?: {
    visible?: boolean;
    direction?: 'left' | 'right';
    position?: 'above' | 'below';
    arrow_label_1?: string;
    arrow_label_2?: string;
    arrow_label_1_hide?: boolean;
    arrow_label_2_hide?: boolean;
    arrow_label_1_direction?: 'left' | 'right';
    arrow_label_2_direction?: 'left' | 'right';
    comm_label_color?: string;
    arrow_svg_offsets?: { x: number; y: number };
    arrow_label_1_offsets?: { x: number; y: number };
    arrow_label_2_offsets?: { x: number; y: number };
    comm_box_offsets?: { x: number; y: number };
    arrow_label_1_color?: string;
    arrow_label_2_color?: string;
    arrow_label_1_line_color?: string;
    arrow_label_2_line_color?: string;
    arrow_label_1_new?: string;
    arrow_label_2_new?: string;
  };
  added_comm_point?:boolean;
  display_communication_point?:string;
  remove_communication_point?:boolean
  modified?: MODIFIEDTAG;
  // Appended to every DOM id derived from this tag (template [id] and
  // component-side getElementById calls) so version-change copies don't
  // collide with the source tag's elements in the DOM.
  dom_id_suffix?: string;
  is_version_change?: boolean;
  show_border?: boolean;
}

export interface TrackTagModel {
  track_name: string;
  assets: TrackTagAsset[];
}

export interface KavachLayoutHeader {
  ref_sig_plan_no: string;
  department: string;
  sip_id: string;
  system_name: string;
  station_name: string;
  station_code: string;
  description: string;
  revision: string;
  drawn_by: string;
  railway_drawing_no: string;
  kavach_sip_id: string;
  sheet_no: string;
  total_sheets: string;
}

export interface TrackParity {
  track_name: string;
  parity: 'odd' | 'even' | 'other';
  reverse: boolean;
  is_edit?: boolean;
}

export interface TagPairDistance {
  track_name: string;
  from: any;
  to: TrackTagAsset;
  distance: number;
  direction: 'up' | 'down';
  is_adjustment_pair?: boolean;
  modified?: any;
}

//Singal Types (asset category)
export enum SignalType {
  STARTER_SIGNAL = "Starter Signal",
  PERMISSIVE_DISTANT_SIGNAL = "Permissive Distant Signal",
  PERMISSIVE_INNER_DISTANT_SIGNAL = "Permissive Inner Distant Signal",
  PERMISSIVE_INNER_DISTANT_SIGNAL_KINK = "Permissive Inner Distant Signal Kink",
  CALLING_HOME_SIGNAL = "Calling Home Signal",
  CALLING_ON_STARTER_SIGNAL = "Calling-on Starter Signal",
  AUTOMATIC_CALLING_HOME_SIGNAL = "Automatic Calling Home Signal",
  BSLB_SIGNAL = "BSLB Signal",
  SLB_SIGNAL = "SLB Signal",
  DEAD_STOP_SIGNAL = "Dead Stop Signal",
  SHUNT_SIGNAL = "Shunt Signal",
  DOUBLE_SHUNT_SIGNAL = "Double Shunt Signal",
  SPI_SHUNT_SIGNAL = "SPI Shunt Signal",
  SPI_SHUNT_CALLING_HOME_SIGNAL = "SPI Shunt Calling Home Signal",
  SPI_SIGNAL = "SPI Signal",
  SHUNT_CALLING_HOME_SIGNAL = "Shunt Calling Home Signal",
  SHUNT_STARTER_SIGNAL = 'Shunt-Starter Signal',
  AUTOMATIC_SHUNT_STARTER_SIGNAL='Automatic Shunt-Starter Signal',
  AUTOMATIC_SIGNAL='Automatic Signal',
  BORDER_SIGNAL = "Border Signal",
  SEMI_AUTOMATIC_BORDER_SIGNAL = "Semi Automatic Border Signal",
  STOP_SIGNAL = "Stop Signal",
  STOP_SIGNAL_UP = "Stop signal up",
  GATE_SIGNAL = 'Gate Signal',
  AUTOMATIC_GATE_SIGNAL = "Automatic Gate Signal",
  SEMI_AUTOMATIC_GATE_SIGNAL = "Semi Automatic Gate Signal",
  VIRTUAL_SIGNAL='Virtual Signal',
  AUTOMATIC_STARTER_SIGNAL = 'Automatic Starter Signal',
  APPROACHING_STATION_BOUNDARY_SIGNAL = 'Approaching Station Boundary',
  FULLY_AUTOMATIC_SIGNAL = 'Fully Automatic Signal',
  SEMI_AUTOMATIC_SIGNAL = 'Semi Automatic Signal',
  SEMI_AUTOMATIC_CALLING_HOME_SIGNAL = 'Semi Automatic Calling Home Signal',
  AUTOMATIC_GATE_CALLING_HOME_SIGNAL = 'Automatic Gate Calling Home Signal',
  SEMI_AUTOMATIC_SHUNT_STARTER_SIGNAL = 'Semi Automatic Shunt-Starter Signal',
  SEMI_AUTOMATIC_SHUNT_CALLING_HOME_SIGNAL = 'Semi Automatic Shunt Calling Home Signal',
  SEMI_AUTOMATIC_GATE_CALLING_HOME_SIGNAL = 'Semi Automatic Gate Calling Home Signal',
  MODIFIED_SEMI_AUTOMATIC_SIGNAL = 'Modified Semi Automatic Signal',
  INTERMEDIATE_BLOCK_SIGNAL = 'Intermediate Block Signal',
  INTERMEDIATE_BLOCK_WITH_BSYMBOL = 'Intermediate Block Border Signal',
  GATE_DISTANT_SIGNAL = 'Gate Distant Signal',
  GATE_INNER_DISTANT_SIGNAL = 'Gate Inner Distant Signal',
  IB_DISTANT_SIGNAL = 'IB Distant Signal',
  IB_INNER_DISTANT_SIGNAL = 'IB Inner Distant Signal',
  GATE_CUM_IB_DISTANT_SIGNAL = 'Gate cum IB Distant Signal',
  GATE_CUM_IB_INNER_DISTANT_SIGNAL = 'Gate cum IB Inner Distant Signal',
  GATE_CUM_DISTANT_SIGNAL = 'Gate Cum Distant Signal',
  GATE_CUM_INNER_DISTANT_SIGNAL = 'Gate Cum Inner Distant Signal',
  AUTOMATIC_ADVANCE_STARTER_CUM_GATE_SIGNAL = 'Automatic Advance Starter cum Gate Signal',
  SEMI_AUTOMATIC_ADVANCE_STARTER_CUM_GATE_SIGNAL = 'Semi Automatic Advance Starter cum Gate Signal',
  AUTOMATIC_ADVANCE_STARTER_CUM_GATE_SIGNAL_WITH_B_SYMBOL = 'Automatic Advance Starter cum Gate Signal with b symbol',
  SEMI_AUTOMATIC_ADVANCE_STARTER_CUM_GATE_SIGNAL_WITH_B_SYMBOL = 'Semi Automatic Advance Starter cum Gate Signal with b symbol',
  ADVANCE_STARTER_SIGNAL='Advance Starter Signal',
  ADVANCE_STARTER_CUM_GATE_DISTANT_SIGNAL_WITH_B_SYMBOL = 'Advance Starter Cum Gate Distant Signal with b symbol',
  ADVANCE_STARTER_CUM_IB_DISTANT_SIGNAL_WITH_B_SYMBOL = 'Advance Starter Cum IB Distant Signal with b symbol',
  ADVANCE_STARTER_CUM_GATE_INNER_DISTANT_SIGNAL_WITH_B_SYMBOL = 'Advance Starter Cum Gate Inner Distant Signal with b symbol',
  ADVANCE_STARTER_CUM_DISTANT_SIGNAL_WITH_B_SYMBOL = 'Advance Starter Cum Distant Signal with b symbol',
  ADVANCE_STARTER_CUM_GATE_SIGNAL_WITH_B_SYMBOL = 'Advance Starter cum Gate Signal with b symbol',
  ADVANCE_STARTER_CUM_GATE_DISTANT_SIGNAL = 'Advance Starter Cum Gate Distant Signal',
  ADVANCE_STARTER_CUM_IB_DISTANT_SIGNAL = 'Advance Starter Cum IB Distant Signal',
  ADVANCE_STARTER_CUM_GATE_INNER_DISTANT_SIGNAL = 'Advance Starter Cum Gate Inner Distant Signal',
  ADVANCE_STARTER_CUM_DISTANT_SIGNAL = 'Advance Starter Cum Distant Signal',
  ADVANCE_STARTER_CUM_GATE_SIGNAL = 'Advance Starter cum Gate Signal',
  AUTOMATIC_ADVANCE_STARTER_SIGNAL = 'Automatic Advance Starter Signal',
  SEMI_AUTOMATIC_ADVANCE_STARTER_SIGNAL = 'Semi Automatic Advance Starter Signal',
  SEMI_AUTOMATIC_ADVANCED_STARTER_WITH_BORDER_SIGNAL = 'Semi Automatic Advance Starter with Border Signal',
  IB_SIGNAL_CUM_DISTANT_SIGNAL_WITH_B_SYMBOL = 'IB Signal Cum Distant Signal with B symbol',
  IB_SIGNAL_CUM_INNER_DISTANT_SIGNAL_WITH_B_SYMBOL = 'IB Signal Cum Inner Distant Signal with B symbol',
  IB_SIGNAL_CUM_GATE_DISTANT_SIGNAL_WITH_B_SYMBOL = 'IB Signal Cum Gate Distant Signal with B symbol',
  IB_SIGNAL_CUM_DISTANT_SIGNAL = 'IB Signal Cum Distant Signal',
  IB_SIGNAL_CUM_INNER_DISTANT_SIGNAL = 'IB Signal Cum Inner Distant Signal',
  IB_SIGNAL_CUM_GATE_DISTANT_SIGNAL = 'IB Signal Cum Gate Distant Signal',
  SPT_SEMI_AUTOMATIC_SIGNAL = 'SPT Semi Automatic Signal',
  AUTOMATIC_BORDER_SIGNAL = 'Automatic Border Signal',
  SEMI_AUTOMATIC_STARTER_SIGNAL = 'Semi Automatic Starter Signal',
  CALLING_HOME_SIGNAL_WITH_B_SYMBOL = 'Calling Home Signal With B Symbol',
}

export enum RailwayZones {
  CENTRAL_RAILWAY = 'Central Railway',
  EASTERN_RAILWAY = 'Eastern Railway',
  EAST_CENTRAL_RAILWAY = 'East Central Railway',
  EAST_COAST_RAILWAY = 'East Coast Railway',
  NORTHERN_RAILWAY = 'Northern Railway',
  NORTH_CENTRAL_RAILWAY = 'North Central Railway',
  NORTH_EASTERN_RAILWAY = 'North Eastern Railway',
  NORTH_FRONTIER_RAILWAY = 'North Frontier Railway',
  NORTH_WESTERN_RAILWAY = 'North Western Railway',
  SOUTHERN_RAILWAY = 'Southern Railway',
  SOUTH_CENTRAL_RAILWAY = 'South Central Railway',
  SOUTH_EASTERN_RAILWAY = 'South Eastern Railway',
  SOUTH_EAST_CENTRAL_RAILWAY = 'South East Central Railway',
  SOUTH_WESTERN_RAILWAY = 'South Western Railway',
  WESTERN_RAILWAY = 'Western Railway',
  WEST_CENTRAL_RAILWAY = 'West Central Railway'
}

export function isWesternOrScrZone(zone: RailwayZones | string | undefined | null): boolean {
  return zone === RailwayZones.WESTERN_RAILWAY
    || zone === RailwayZones.WEST_CENTRAL_RAILWAY
    || zone === RailwayZones.CENTRAL_RAILWAY
    || zone === RailwayZones.SOUTH_CENTRAL_RAILWAY;
}

export enum BoardDisplay {
  CROSS = 'cross',
  STAR = 'star',
  HASH = 'hash',
  NIZ = 'NIZ',
  PLUS = 'plus',
  TRIANGLE = 'triangle',
  NORMAL = 'normal',
  HORN = 'hornboard',
  CAUTION = 'cautionboard',
  CROSS_WITHOUT_DOTS = 'cross_without_dots',
  CROSS_WITHOUT_DOTS_WITH_HASH = 'cross_without_dots_with_hash',
  SPI = 'SPI',
  SHUNTING = 'shunting',
}

export enum OEMs {
  HBL = 'HBL',
  KERNEX = 'Kernex',
  SVAGA = 'SVAGA',
  // Add other OEMs as needed
}



//Signal Tins
export interface SingalAspectWithRootIndicatorTin {
  aspect: string;
  count?: number;
  directions?: any;
}

export interface SignalAssetTin {
  asset_id: string;
  location: number;
  visible_left_to_right: string; //True or False;
  visible_right_to_left: string; //True or False;
  asset_category: string;
  signal_aspects: string[];
  is_beside_station: string; //True or False;
  non_kavach: string; //True or False;
  type_of_communication_point: string;
  aspects_with_root_indicators: any;
  berthing_track_signal?: boolean; //True or False;
  tin_numbers: string[];
}

export interface TrackSignalTin {
  track_name: string;
  assets: SignalAsset[];
}



export interface TrackDirectionMapping{
  id?:any;
  trackCode: string;
  trackFullName: string;
  startTrackFullName?: string;
  endTrackFullName?: string;
  isLeftDirection: boolean | null;
  isRightDirection: boolean | null;
  startIsLeftDirection?: boolean | null;
  startIsRightDirection?: boolean | null;
  endIsLeftDirection?: boolean | null;
  endIsRightDirection?: boolean | null;
  isStartNameHidden?: boolean;
  isEndNameHidden?: boolean;
}

export interface RevisionHistoryEntry {
  revision_id: string;      // e.g., "rev_0"
  rev_no: number | string;           // e.g., 0, 1, 2
  date: string;             // Format: "DD.MM.YYYY"
  details: string[];        // List of change descriptions
}

export interface RevisionHistory {
  revision_history: RevisionHistoryEntry[];
}

//TAG USAGE TABLE
export interface AllottedTags {
  tags: string;
  used_count: number;
}

export interface RFIDInfo {
  range: string;
  allotted: AllottedTags;
  spare: string;
  last_tag?: number; // Optional, used for the last tag in the range
}

export interface TINInfo {
  range: string;
  allotted: AllottedTags;
  spare: string;
  last_tin?: number; // Optional, used for the last tin in the range
}

export interface StationTagData {
  name: string;
  station_id: number | string;
  rfid: RFIDInfo;
  tin: TINInfo;
  border_rfid_tags: number[];
}

export interface TagSummaryData {
  total_tags: number;
  station_tag_table_persist: any;
  notes?:any;
  stations: StationTagData[];
}


//Author Review Table
/* ───────── Interfaces (keep in a models file if you like) ───────── */
export interface StationHeader {
  station_name: string;        // e.g. "ROHALKHURD (RLK)"
  division: string;     
  hindi_name?:any       // e.g. "Kota Division, WC Railway"
}

export interface RefBlock {
  label?: string;               // "REF"
  value?: string;               // "SIP: RLK-5057/ALT-'D'"
  "sip_value"?: string,
  "toc_value"?: string;
  kavach_ref?:any;
}

export interface AuthorApproval {
  role: string;         // e.g., "Prepared By", "Checked By"
  sign?: string;        // signature text / base64 / file-name – optional
  name?: string;        // person’s name – optional
  designation?: string; // designation text from author review JSON – optional
}
export interface AuthorReviewTable {
  station: StationHeader;
  ref: RefBlock;
  main_title: string;
  layout_version: string;
  subtitle: string;
  approvals: AuthorApproval[];  // Updated reference here
  logo_url: string;
  
}



export interface DefaultFontSizesScr {
  rfidTags: number;
  rfidTagLocation: number;
  tins: number;
  tableStationTitle: number;
  tableContent: number;
  tableHeaders: number;
  signals: number;
  turnouts: number;
  trapPoints: number;
  trackNames: number;
  junctions: number;
  junctionSub: number;
  trackSections: number;
  distancePairText: number;
  boardText: number;
  ympPoints: number;
  fmPoints: number;
  commText: number;
  centerLineText: number;
  deadends: number;
  utilText: number;
  adjustments: number;
  trackDirections: number;
  stationDirections: number;
}

export interface AssetDpDialog {
  track_name: any | null,
  direction: any | null,
  distance: any | null,
  dpError: any | null,
  is_dotted: boolean,
  color: string
}

// Box of an asset on the RFID layout, in layout px at 100% zoom
export interface AssetCoordinateBox {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface AssetCoordinates extends AssetCoordinateBox {
  asset_id: string | null;
  // A list of strings for assets that are on more than one track, like an LC gate, otherwise a string
  track_name: string | string[] | null;
  type_of_asset?: string;
  // For a communication point, these say what the key is: the point's own id, or the id of the asset it is drawn with.
  // The point's own id; null when the station has no id for it
  communication_point_id?: string | null;
  // The type of asset it is drawn with, like "Normal Tags" or "Signal"; null when it is not drawn
  attached_to?: string | null;
  // The id of the tag or signal it is drawn with; null when it is not drawn
  attached_asset_id?: string | null;
  from?: DistancePairEnd;
  to?: DistancePairEnd;
}

// One end of a distance pair. id is the same id used as the key of that tag.
export interface DistancePairEnd {
  id: string | null;
  asset_id: string | null;
  type_of_tag: string | null;
}

// One item of a tag's meta_data_dependencies. The backend writes "Type"; older data that was changed to this form has "type".
export interface TagDependency {
  asset_id?: string | null;
  Type?: string;
  type?: string;
}

// Box of one end of a turnout
export interface CrossingEndCoordinates extends AssetCoordinateBox {
  asset_id: string | null;
  track_name: string | null;
}

// A turnout joins two tracks, so it has one box for each end. An end that is not drawn is left out.
export interface CrossingCoordinates {
  asset_id: string | null;
  track_name: string | string[] | null;
  Track_1_coords?: CrossingEndCoordinates;
  Track_2_coords?: CrossingEndCoordinates;
}

// asset key -> coordinates
export type AssetCoordinatesGroup = Record<string, AssetCoordinates | CrossingCoordinates>;

// asset type -> asset key -> coordinates. All tag groups are inside "tags": tag group -> tag key -> coordinates.
// Ex: map["Signal"]["9198..."] gives one signal, map.tags["Normal Tags"]["abc..."] gives one tag.
export interface AssetCoordinatesMap {
  [assetType: string]: AssetCoordinatesGroup | Record<string, Record<string, AssetCoordinates>>;
  tags: Record<string, Record<string, AssetCoordinates>>;
}

// The asset coordinates JSON sent for verification
export interface AssetCoordinatesFile {
  station_uuid: string | null;
  station_name: string;
  layout_info: {
    unit: 'px';
    origin: 'top_left';
    zoom: 1;
    layout_width: number;
    layout_height: number;
    px_per_km: number;
  };
  // Only assets drawn on the layout are listed
  asset_to_coordinates_map: AssetCoordinatesMap;
}

export interface UploadRfidDocumentsResponse {
  result: string;
  status: boolean;
  code: number;
}

// ==========================================
// Tag and TIN Persistence & Change Tracking Interfaces
// ==========================================

export type FlatStationTag = TrackTagAsset | TurnoutTag;

/**
 * Minimal contract required for tag synchronization (tag_edit ↔ manual_edit_tag / rfid_tag).
 */
export interface TagEditSyncable {
  rfid_tag?: string;
  manual_edit_tag?: string;
  tag_edit?: boolean;
}

/**
 * Minimal contract required for TIN synchronization (tin_edit ↔ manual_edit_tin_number / tin_number).
 */
export interface TinEditSyncable {
  tin_number?: string;
  manual_edit_tin_number?: string;
  tin_edit?: boolean;
}

/**
 * Base interface for an editable tag in persistence flows.
 * Requires immutable identification: `id` and `rfid_tag` are mandatory.
 */
export interface EditableTag extends TagEditSyncable {
  id: string;
  rfid_tag: string;
  manual_edit_tag?: string;
  tag_edit?: boolean;
  mode?: string;
  location?: number | string | null;
  track_name?: string;
}

/**
 * Base interface for an editable TIN in persistence flows.
 * Requires `tin_number` as mandatory.
 */
export interface EditableTin extends TinEditSyncable {
  tin_number: string;
  manual_edit_tin_number?: string;
  tin_edit?: boolean;
  mode?: string;
  id?: string;
}

/**
 * Information payload recorded upon tag deletion.
 */
export interface DeletedTagInfo {
  rfid_tag: string;
  mode?: string;
}

/**
 * Information payload recorded upon TIN deletion.
 */
export interface DeletedTinInfo {
  tin_number: string;
  mode?: string;
}

/**
 * Nested tag representation within a reference asset.
 */
export interface ReferenceAssetTag {
  tag_obj?: TagEditSyncable;
  rfid_tag?: string;
  manual_edit_tag?: string;
  tag_edit?: boolean;
  location?: number | string;
  [key: string]: any;
}

/**
 * Reference asset metadata associated with tags.
 */
export interface TagReferenceAsset {
  asset_id?: string;
  type_of_asset?: string;
  tags_between?: ReferenceAssetTag[];
  [key: string]: any;
}

/**
 * Tag entry structure within regeneration updates and tag configurations.
 */
export interface RegenerateTagEntry extends EditableTag {
  new_id?: string;
  old_rfid_tag?: string;
  _timestamp?: number;
  _change_type?: 'added' | 'deleted' | 'modified' | string;
  reference_asset?: TagReferenceAsset;
  [key: string]: any;
}

export type TagConfigLeaf = RegenerateTagEntry | { [tagId: string]: RegenerateTagEntry };

export interface TagConfigContainer {
  [tagTypeOrTrack: string]: {
    [trackNameOrTagId: string]: TagConfigLeaf;
  };
}

/**
 * Delta value for display locations: numeric offset or 2D coordinate delta.
 */
export type DisplayLocationDelta = number | { x?: number; y?: number; [key: string]: any };
export type DisplayLocationsMap = Record<string, Record<string, DisplayLocationDelta>>;

export interface ChangeTrackingMap<TDiff = any> {
  signals?: {
    [trackName: string]: {
      [signalId: string]: {
        [fieldName: string]: any;
      };
    };
  };
  tags?: TagConfigContainer;
  crossings?: {
    [crossingId: string]: {
      [fieldName: string]: any;
    };
  };
  dead_ends?: {
    [deadEndId: string]: {
      [fieldName: string]: any;
    };
  };
  trap_points?: {
    [trapPointId: string]: {
      [fieldName: string]: any;
    };
  };
  track_section_points?: {
    [pointId: string]: {
      [fieldName: string]: any;
    };
  };
  track_section_points_names?: {
    [pointId: string]: {
      [fieldName: string]: any;
    };
  };
  distance_pairs?: TDiff;
  circuit_pairs?: TDiff;
  [key: string]: any;
}

export interface RegeneratePersistenceInfo {
  updated_data?: ChangeTrackingMap;
  added_tags_config?: TagConfigContainer;
  deleted_tags_config?: TagConfigContainer;
  updated_display_locations_map?: DisplayLocationsMap;
  [key: string]: any;
}

